import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetProjectAiSummary(projectId) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/project/${projectId}/ai-summary`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestProjectAiSummary(projectId) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/project/${projectId}/ai-summary`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetDailyActivityAiSummary(date) {
    const qs = date ? `?date=${encodeURIComponent(date)}` : '';
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/ai/daily-activity-summary${qs}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDailyActivityAiSummary(date) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/ai/daily-activity-summary`,
        data: { date },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetWeeklyActivityAiSummary(weekStart) {
    const qs = weekStart ? `?week=${encodeURIComponent(weekStart)}` : '';
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/ai/weekly-activity-summary${qs}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestWeeklyActivityAiSummary(weekStart) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/ai/weekly-activity-summary`,
        data: { week: weekStart },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetMonthlyActivityAiSummary(month) {
    const qs = month ? `?month=${encodeURIComponent(month)}` : '';
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/ai/monthly-activity-summary${qs}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestMonthlyActivityAiSummary(month) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/ai/monthly-activity-summary`,
        data: { month },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetEndOfDayChecklist(date) {
    const qs = date ? `?date=${encodeURIComponent(date)}` : '';
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/ai/end-of-day-checklist${qs}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRegenerateQuote(quoteId, data) {
    return axios.request({
        method: 'put',
        url: `${getApiUrl()}/quote/${quoteId}/regenerate`,
        data: data || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetSuggestions(params = {}) {
    const search = new URLSearchParams();
    if (params.scope) search.set('scope', params.scope);
    if (params.status) search.set('status', params.status);
    if (params.execution) search.set('execution', params.execution);
    if (params.start) search.set('start', params.start);
    if (params.limit) search.set('limit', params.limit);
    const qs = search.toString();
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/ai/suggestions${qs ? `?${qs}` : ''}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetSuggestion(suggestionId) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/ai/suggestions/${suggestionId}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestApproveSuggestion(suggestionId, data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/ai/suggestions/${suggestionId}/approve`,
        data: data || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRejectSuggestion(suggestionId, data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/ai/suggestions/${suggestionId}/reject`,
        data: data || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetSuggestionRecipients(suggestionId) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/ai/suggestions/${suggestionId}/recipients`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRedirectSuggestion(suggestionId, data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/ai/suggestions/${suggestionId}/redirect`,
        data: data || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGenerateSuggestions() {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/ai/suggestions/generate`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestExportAiConversation(conversationId, data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/ai/conversation/${conversationId}/export`,
        data: data || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAskAiQuestion(data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/ai/ask`,
        data: data || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetAiAnswer(contextId) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/ai/ask/${encodeURIComponent(contextId)}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetAiConversation(conversationId) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/ai/conversation/${encodeURIComponent(conversationId)}`,
        withCredentials: true,
        crossorigin: true,
    });
}
